jq('#all_participation_areas').change(function() {
    if (jq('#all_participation_areas:checked').length > 0) {
        jq('.participation-option').each(function() {
            jq(this).prop('checked', true).addClass('disabled');    
        });
    } else {
        jq('.participation-option').each(function() {
            jq(this).prop('checked', false).removeClass('disabled');    
        });        
    }
});
// video sound control added 
jq('.sound').click(function(){
    var current_video = jq(this).parent().parent().find('video');
    if (current_video.prop('muted')) {
        current_video.prop('muted', false); 
        jq(this).find('.video-sound').addClass('muted');
    } else {
        current_video.prop('muted', true);
        jq(this).find('.video-sound').removeClass('muted');
    }
})
// Aces Slider with Number of Slides
jq(document).ready(function () {
    let acesSlider =  jq('.aces-slider');
    if (acesSlider.length) {
        var acesCurrentSlide;
        var acesSliderCounter = document.getElementById('aces-slide-counter');
        var acesSliderOptions = document.getElementById('aces-slider-options');
        
        // Update the counter
        var updateAcesSliderCounter = function(slick, currentIndex) {
            acesCurrentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            jq(acesSliderCounter).text(acesCurrentSlide + '/' +slidesCount)
        };
        acesSlider.on('init', function(event, slick) {
            updateAcesSliderCounter(slick);
        });
        
        acesSlider.on('afterChange', function(event, slick, acesCurrentSlide) {
            updateAcesSliderCounter(slick, acesCurrentSlide);
        });
  
        acesSliderOptions = JSON.parse(acesSliderOptions.innerHTML);
        acesSlider.slick(acesSliderOptions);
    }
    let accoladesSlider =  jq('.accolade-slider');
    if (accoladesSlider.length) {
        var accoladesSliderCounter = jq('#accolades-slide-counter');
        
        accoladesSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            let currentDot = jq('.slick-dots .slick-active').text();
            var totalSlides = slick.$dots && slick.$dots[0] ? slick.$dots[0].children.length : slick.slideCount;
            accoladesSliderCounter.text(currentDot + '/' + totalSlides);
        });
        
        accoladesSlider.slick({
            infinite: true,
            variableWidth: false,
            draggable: true,
            arrows: true,
            prevArrow: ".module-careers-accolades .slide-prev",
            nextArrow: ".module-careers-accolades .slide-next",
            appendArrows: ".module-careers-accolades .slider-controls-counter",
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true, 
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2, 
                        slidesToScroll: 1
                    }
                }, 
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1, 
                        slidesToScroll: 1
                    }
                }
            ]
        });    

    }
});
// Fix the subnav from covering the first module padding due to thickness
// and stacking the subpages
// Add the class extra-margin if the height exceeds 150px
jq(document).ready(function () {
    if (jq('.sub-navigation').height() > 150) {
        jq('.sub-navigation-wrapper').addClass('extra-margin');
    }
});

//filtering
jq(document).ready(function () {
    var $filterSelect = jq(".row-filter .eq-select");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".row-filter .eq-select").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
            	var full_url = url + "?year=" + jq(this).val();
            	if (window.location.href != full_url) {
            		window.location.href = full_url;
            	}
            } else {
            	if (window.location.href != url) {
            		window.location.href = url;
            	}
            }
       });
    }
    
   
});
// Blog page cards match height against all cards
jq(function() {
	jq('.blog-item.content-box .text').matchHeight({
        byRow: false,
    });
});

// Brand cards: wait for images to load, then set image wrappers to min height (no stretching)
jq(document).ready(function () {
    var $module = jq('.module-brand-cards');
    if (!$module.length) return;
    $module.each(function () {
        var $container = jq(this);
        var $wrappers = $container.find('.brand-card-image').has('img');
        var $imgs = $wrappers.find('img');
        if (!$imgs.length) return;
        var n = $imgs.length;
        var loaded = 0;
        function onLoad() {
            loaded++;
            if (loaded !== n) return;
            var minH = Infinity;
            $wrappers.each(function () {
                var h = jq(this).outerHeight();
                if (h < minH) minH = h;
            });
            if (minH !== Infinity && minH > 0) {
                $wrappers.css('height', minH + 'px');
            }
        }
        $imgs.each(function () {
            var img = this;
            if (img.complete) onLoad();
            else jq(img).on('load', onLoad);
        });
    });
});

// Full-width image slider (clickable image per slide)
jq(document).ready(function () {
    var slider = jq('.row-slider-image-full-width .slider-image-full-width');
    if (slider.length) {
        slider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '.row-slider-image-full-width .slide-prev',
            nextArrow: '.row-slider-image-full-width .slide-next',
            appendArrows: '.row-slider-image-full-width .slider-image-full-width-nav',
            dots: false,
            adaptiveHeight: true
        });
    }
});
